import { PageProps } from 'gatsby'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Background } from '../components/landing/background/background'
import { Footer } from '../components/layout/footer/footer'
import { Header } from '../components/layout/header/header'
import { landing as landingDe } from '../data/landing/de'
import { landing as landingEn } from '../data/landing/en'

const Layout = ({ children, path }: PageProps) => {
  const { i18n } = useTranslation()

  const dataByLanguage = {
    en: landingEn,
    de: landingDe,
  }

  const currentLanguage = i18n.resolvedLanguage as keyof typeof dataByLanguage
  const landingPageData = dataByLanguage[currentLanguage]

  let prefersDark: boolean = false
  if (typeof window !== 'undefined') {
    prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  }

  const [isDark, setIsDark] = useState(prefersDark)

  useEffect(() => {
    const root = document.documentElement
    if (isDark) {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }, [isDark])

  const fullFooter = path === '/'

  return (
    <Background className="flex flex-col min-h-screen">
      <Header
        title={landingPageData.profile.name}
        isDarkTheme={isDark}
        onToggleTheme={() => setIsDark((prev) => !prev)}
      />

      {children}

      <Footer
        variant={fullFooter ? 'full' : 'legal-only'}
        {...landingPageData.contacts}
        name={landingPageData.profile.name}
        image={landingPageData.profile.image}
      />
    </Background>
  )
}

export default Layout
